<template lang="pug">
    crud-form(
        v-bind="formProps"
        @calculate="calculate"
        submitText="Guardar"
        @submitForm="submitForm($event)"
        @reset="resetForm"
        )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import EmployeeService from '@/services/api/employee'
import IsaprePlanService from '@/services/api/isaprePlan/IsaprePlanServices'
import HealthAffiliationService from '@/services/api/healthAffiliation'
import PrevisionService from '@/services/api/prevision'
import IsapreTypeService from '@/services/api/isapreType'
//
import { EmployeeHealthFields, EmployeeFields } from './fields'
import { EmployeesListHeaders } from './headers'
//
export default {
    components: {
        'crud-form': CrudForm,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                fields: this.formFields,
                ref: 'form',
                editable: this.$can('EDIT_EMPLOYEE'),
                readOnly: !this.$can('EDIT_EMPLOYEE'),
            }
        },
    },
    data() {
        return {
            formData: null,
            formFields: EmployeeHealthFields,
            originalFields: EmployeeHealthFields,
        }
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        //-
        calculate: async function(event) {
            switch (event.field) {
                case 'hr_health_affiliation_id':
                    switch (event.value) {
                        case 1:
                            //- Fonasa
                            this.formData.hr_health_affiliation_id = 1
                            this.hide()
                            this.editFill(this.formData)
                            break
                        case 2:
                            //- Isapre
                            this.formData.hr_health_affiliation_id = 2
                            this.hide()
                            this.editFill(this.formData)
                            break
                    }
                case 'hr_prevision_id':
                    this.formFields[0].value = this.$refs.form.vmodels.hr_prevision_id
                    break
            }
        },
        //-
        hide: function() {
            //-
            if (this.formData.hr_health_affiliation_id === 1) {
                let newFonasaFields = this.originalFields.filter(
                    item =>
                        item.field === 'hr_prevision_id' ||
                        item.field === 'hr_health_affiliation_id'
                )
                this.formFields = newFonasaFields
            } else {
                this.formFields = this.originalFields
            }
            this.formFields[0].value = this.$refs.form.vmodels.hr_prevision_id
        },
        //- fill for case edit isapre plan
        editFill: async function(employee) {
            //-
            await this.editReset()
            //-
            if (employee.hr_isapre_plan_active === null) {
                // this.$refs.form.vmodels.hr_prevision_id = employee.hr_prevision_id
                this.$refs.form.vmodels.hr_health_affiliation_id =
                    employee.hr_health_affiliation_id
            } else {
                // this.$refs.form.vmodels.hr_prevision_id = employee.hr_prevision_id
                this.$refs.form.vmodels.hr_health_affiliation_id =
                    employee.hr_health_affiliation_id
                this.$refs.form.vmodels.hr_isapre_type_id =
                    employee.hr_isapre_plan_active.hr_isapre_type_id
                this.$refs.form.vmodels.uf_amount =
                    employee.hr_isapre_plan_active.uf_amount
            }
        },
        //- reset for case edit isapre plan
        editReset: async function() {
            if (this.formData.hr_health_affiliation_id === 1) {
                this.formFields[1].value = this.$refs.form.vmodels.hr_health_affiliation_id
            } else {
                this.formFields[1].value = this.$refs.form.vmodels.hr_health_affiliation_id
                this.formFields[2].options.data = await IsapreTypeService.fetchAll()
            }
        },
        //-
        getInfoEmployee: async function() {
            const employee = await EmployeeService.fetchById(
                this.$route.params.id
            )
            this.formData = employee
            this.hide()
            this.fill(employee)
        },
        //-
        fill: async function(employee) {
            console.log('Employee', employee)
            //-
            await this.reset()
            //-
            if (employee.hr_isapre_plan_active === null) {
                this.$refs.form.vmodels.hr_prevision_id =
                    employee.hr_prevision_id
                this.$refs.form.vmodels.hr_health_affiliation_id =
                    employee.hr_health_affiliation_id
            } else {
                this.$refs.form.vmodels.hr_prevision_id =
                    employee.hr_prevision_id
                this.$refs.form.vmodels.hr_health_affiliation_id =
                    employee.hr_health_affiliation_id
                this.$refs.form.vmodels.hr_isapre_type_id =
                    employee.hr_isapre_plan_active.hr_isapre_type_id
                this.$refs.form.vmodels.uf_amount =
                    employee.hr_isapre_plan_active.amount
                this.$refs.form.vmodels.hr_previred_currency_id =
                    employee.hr_isapre_plan_active.hr_previred_currency_id
                this.$refs.form.vmodels.contract_number =
                    employee.hr_isapre_plan_active.contract_number
            }
        },
        //-
        reset: async function() {
            if (this.formData.hr_health_affiliation_id === 1) {
                this.formFields[0].options.data = await PrevisionService.fetchAll()
                this.formFields[1].options.data = await HealthAffiliationService.fetchAll()
            } else {
                this.formFields[0].options.data = await PrevisionService.fetchAll()
                this.formFields[1].options.data = await HealthAffiliationService.fetchAll()
                this.formFields[2].options.data = await IsapreTypeService.fetchAll()
            }
        },
        //-
        showSnackbar: function(type, title) {
            this.initSnackbar(this.fillSnack(type, title))
        },
        //-
        resetForm: function() {
            console.log('hola reset')
            // this.fill(this.formData)
        },
        //-
        submitForm: async function(event) {
            //- Set Initial Values
            this.formData.hr_prevision_id = event.hr_prevision_id
            this.formData.hr_health_affiliation_id =
                event.hr_health_affiliation_id
            //- Create new Isapre Plan
            if (event.hr_health_affiliation_id === 2) {
                //- Crear plan de isapre y actualizar empleado!
                const response = await EmployeeService.update(
                    this.$route.params.id,
                    this.formData
                )
                if (response.status == 'success') {
                    await this.createIsaprePlan(event)
                    this.snackbarResponse(response)
                }
            } else if (event.hr_health_affiliation_id === 1) {
                //- Actualizar Previsión de empleado en FONASA!
                const response = await EmployeeService.update(
                    this.$route.params.id,
                    this.formData
                )
                if (response.status == 'success') {
                    await this.deleteIsaprePlan(event)
                    this.snackbarResponse(response)
                }
            }
        },
        //- Create Isapre Plan Method
        createIsaprePlan: async function(event) {
            let plan = {}
            plan.hr_employee_id = this.formData.id
            plan.hr_isapre_type_id = event.hr_isapre_type_id
            plan.amount = parseFloat(event.uf_amount)
            plan.hr_previred_currency_id = event.hr_previred_currency_id
            plan.contract_number = event.contract_number
            const response = await IsaprePlanService.createIsaprePlan(plan)
            this.snackbarResponse(response)
        },
        //- Delete Isapre Plan Method
        deleteIsaprePlan: async function(event) {
            const response = await IsaprePlanService.deleteIsaprePlan(
                this.formData.hr_isapre_plan_active.id
            )
            this.snackbarResponse(response)
        },
        //- Snackbar Method
        snackbarResponse: function(response) {
            switch (response.status) {
                case 'error':
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Los cambios fueron guardados exitosamente.',
                        'Éxito.'
                    )
                    break
                default:
                    break
            }
        },
    },
    mounted() {
        this.getInfoEmployee()
    },
    watch: {
        $route() {
            this.getInfoEmployee()
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
}
</script>
